import { addDays, isoWeek, type DateKey } from '@kff/engine';

const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MON_SV = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const DOW_SV = ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'];
const d = (k: DateKey) => new Date(k + 'T12:00:00Z');

export const h = (n: number | null | undefined): string => (n === null || n === undefined ? '–' : `${Math.round(n * 10) / 10} h`);
export const dm = (k: DateKey) => `${+k.slice(8, 10)} ${MON[+k.slice(5, 7) - 1]}`;
export const ddm = (k: DateKey) => `${DOW[d(k).getUTCDay()]} ${dm(k)}`;
export const dmSv = (k: DateKey) => `${+k.slice(8, 10)} ${MON_SV[+k.slice(5, 7) - 1]}`;
export const ddmSv = (k: DateKey) => `${DOW_SV[d(k).getUTCDay()]} ${dmSv(k)}`;

/** "W45 · 2–8 Nov" */
export function weekLabel(mon: DateKey): string {
  const sun = addDays(mon, 6);
  return `W${isoWeek(mon)} · ` + (mon.slice(5, 7) === sun.slice(5, 7) ? `${+mon.slice(8, 10)}–${dm(sun)}` : `${dm(mon)} – ${dm(sun)}`);
}
/** "v. 45 · 2–8 nov" */
export function weekLabelSv(mon: DateKey): string {
  const sun = addDays(mon, 6);
  return `v. ${isoWeek(mon)} · ` + (mon.slice(5, 7) === sun.slice(5, 7) ? `${+mon.slice(8, 10)}–${dmSv(sun)}` : `${dmSv(mon)} – ${dmSv(sun)}`);
}

export const when = (iso: string, lang: 'en' | 'sv' = 'en') =>
  new Intl.DateTimeFormat(lang === 'sv' ? 'sv-SE' : 'en-GB', { timeZone: 'Europe/Stockholm', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(new Date(iso));

/** A phone number as a link that rings on a phone (spaces and dashes out, + kept). */
export const telHref = (phone: string): string => `tel:${phone.replace(/[^\d+]/g, '')}`;
